export class ReesizeEventHandler {
    constructor() {
        this.callbacks = [];
        this.onResize = this.onResize.bind(this);
        $(window).on("resize", this.onResize);
    }
    onResize() {
        for (const callback of this.callbacks) {
            callback();
        }
        setTimeout(() => {
            for (const callback of this.callbacks) {
                callback();
            }
        }, 100);
    }
    add(callback) {
        this.callbacks.push(callback);
    }
    drop() {
        this.callbacks = [];
        $(window).off("resize", this.onResize);
    }
}
//# sourceMappingURL=resize.js.map